import { ReactNode } from 'react';

interface InteractionsProps {
  children: ReactNode;
}

export const Interactions = ({ children }: InteractionsProps) => {
  return <>{children}</>;
};
